import AccordionView, { AccordionHeader, AccordionContent } from "../AccordionView";
import { Stack } from "@mui/material";
import { SVGAsset } from "res";

/**
 * @function AccordionSection
 * @param {STRING} className - Class name for the container of the accordion.
 * @param {STRING} text - The primary label of the accordion.
 * @param {BOOLEAN} defaultExpanded - Boolean that determines if the accordion is expanded by default.
 * @returns {React.Component}
 * @exported false
 * @description An accordion that toggles content.
 * @example
 * <AccordionSection>
 *  { Some content goes here. }
 * </AccordionSection>   
 */
export default function AccordionSection(props) {
    // Custom classes added if needed later.
    const className = props.className ?? "";
    const customAccordionViewClass = props.customAccordionViewClass ?? "";
    const customAccordionHeaderClass = props.customAccordionHeaderClass ?? "";
    const customAccordionContentClass = props.customAccordionContentClass ?? "";
    const header = props.header ?? "[Some Header]";  
    const defaultExpanded = String(props.defaultExpanded ?? true) === "true";

    return (
    <AccordionView className={`flex-height ${ className } ${ customAccordionViewClass }` } defaultExpanded={ defaultExpanded }>
        <AccordionHeader className={ customAccordionHeaderClass } >
        <Stack direction="row" alignItems="center">
            <span className="flex-width">{ header }</span>
            <SVGAsset id="DownChevronIcon" className="chevron-icon left-icon set-width" />
        </Stack>
        </AccordionHeader>
        <AccordionContent className={ `flex-container flex-vertical ${ customAccordionContentClass }` }>
        { props.children ?? `[Some content]` }
        </AccordionContent>
    </AccordionView>
    );
}